export default __webpack_public_path__ + "static/media/advikaedutechretail2.3ec971f1.jpg";